<template>
  <div
    class="flex flex-wrap flex-direction-column align-start gap-3"
    :data-qa="`offer-key-${item.id}`">
    <div
      class="flex flex-wrap gap-3"
      data-qa="bidder-info">
      <BidderIsWinner
        v-if="item.selectedBid"
        class="my-auto"
        :color="item.hasPositionNotSelectedBid ? '#ddd309' : '#7DE199'"/>
      <router-link
        :class="[{'secondary__green_not_active--text': item.bidStatus == 'DRAFT' }, 'hover-underline']"
        :to=" item.bidderInfo && !onlyReview ? {name: 'supplier',
                                                params: {org: $route.params.org, id: item.bidderInfo.organizationId},
                                                query: { tenderId: tender.tenderId }}
          : ''">
        {{ item.bidderInfo ? item.bidderInfo.organizationName.trim() || item.bidderInfo.fullName.trim() || '–' : '–' }}
      </router-link>
    </div>
    <div
      v-if="item.bidderInfo && item.bidderInfo.rating != undefined"
      class="opacity-6 flex gap-3"
      data-qa="bidder-status-info">
      <VerificationStatus
        v-if="item.bidderInfo && item.bidderInfo.verificationStatus == 'VERIFIED'"
        class="my-auto"
        :status="item.bidderInfo.verificationDecision"/>
      <span
        data-qa="rating">
        {{ $t('Tenders.Rating') }}: {{ item.bidderInfo.rating }}
      </span>
    </div>
    <ExternalParticipantChip
      v-if="item.foreignBidderBid && !hide_foreign"/>
    <OfferRequirements
      v-if="growthBook.ai_functionals"
      :label-class="'opacity-6'"
      :requirement="item.requirements"
      @showModalInfo="showModalInfo(item.requirements)"/>
    <DraftBidChip
      v-if="item.bidStatus == 'DRAFT'"
      :old_tender="tender.previousTender ? tender.previousTender.tenderNumber : ''"/>
  </div>
</template>
<script>
import BidderIsWinner from 'components/tenders/BidderIsWinner.vue'
import VerificationStatus from 'components/tenders/VerificationStatus.vue'
import DraftBidChip from 'components/tenders/tender page/DraftBidChip.vue'
import ExternalParticipantChip from 'components/tenders/tender page/ExternalParticipantChip.vue'
import OfferRequirements from 'components/tenders/tender page/tender tabs/OfferRequirements.vue'

export default {
  name: 'bidderInfoCell',
  data() {
    return {}
  },
  methods: {
    showModalInfo(requirement) {
      this.$emit('showRequirements', requirement)
    },
  },
  computed: {},
  components: {
    DraftBidChip,
    BidderIsWinner,
    OfferRequirements,
    VerificationStatus,
    ExternalParticipantChip
  },
  created() {},
  props: {
    item: {
      type: Object,
    },
    tender: {
      type: Object,
    },
    onlyReview: {
      type: Boolean,
      default: false
    },
  },
}
</script>
<style scoped lang="scss">
</style>
